var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IschromeIOS"},[_c('div',{staticClass:"IschromeIOS__text",domProps:{"innerHTML":_vm._s(_vm.trans('nocam'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }